import Rollbar from 'rollbar';

export const rollbarConfig = {
  accessToken: '3279b2c96cb34408aa2107d9026e3234',
  environment: process.env.NODE_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
};

export const rollbar = new Rollbar(rollbarConfig);